export class Map<T> {
    private items: { [key: string]: T };
    private lengthC: number = 0;

    constructor() {
        this.items = {};
    }

    add(key: string, value: T): void {
        this.lengthC++;
        this.items[key] = value;
    }

    has(key: string): boolean {
        return key in this.items;
    }

    get(key: string): T {
        return this.items[key];
    }

    length() {
        return this.lengthC;
    }

    delete(key: string) {
        delete this.items[key];
        this.lengthC--;
    }
}